export class ArrayHelper {
	constructor(props) {}

	/**
	 * Сортирует по возрастанию
	 * @param array {Array}
	 * @returns Array
	 */
	sortArrayInAsc(array) {
		return array.sort(function (a, b) {
			return a - b;
		});
	}

	/**
	 * Сортирует по возрастанию по параметру
	 * @param array {Array}
	 * @param propertyName {String}
	 * @returns Array
	 */
	sortArrayInAscByProperty(array, propertyName) {
		return array.sort(function (a, b) {
			return a[propertyName] - b[propertyName];
		});
	}

	/**
	 * Функция убирающая повторы по имени свойства
	 * @param  {Array} array
	 * @param  {String} propertyName
	 * @return {Array}
	 */
	uniqueArrayByProperty(array, propertyName) {
		return array.filter(
			(e, i) => array.findIndex(a => a[propertyName] === e[propertyName]) === i
		);
	}

	/**
	 * @return {Array}
	 */
	convertObjectToArray(objectArray) {
		const convertedArray = [];

		$.each(objectArray, (i, objectElement) => convertedArray.push(objectElement));

		return convertedArray;
	}
}

export const arrayHelper = new ArrayHelper();
